import { PDPalet } from './colors';

export const ListColorSchemes: Record<string, PDPalet> = {
  pastel: {
    red: { name: 'red', hex: '#e08e8e' },
    orange: { name: 'orange', hex: '#ffaa48' },
    yellow: { name: 'yellow', hex: '#ddcf69' },
    green: { name: 'green', hex: '#abd997' },
    blue: { name: 'blue', hex: '#c3e7e8' },
    purple: { name: 'purple', hex: '#cdb5d9' },
    grey: { name: 'grey', hex: '#c1c1c1' },
    black: { name: 'black', hex: '#000000' },
    white: { name: 'white', hex: '#ffffff' },
    none: { name: 'none', hex: 'transparent' },
    me: { name: 'none_dark', hex: '#1da8df' },
  },
  bright: {
    red: { name: 'red', hex: '#ea5555' },
    orange: { name: 'orange', hex: '#f39c3c' },
    yellow: { name: 'yellow', hex: '#ecd03f' },
    green: { name: 'green', hex: '#6eb35e' },
    blue: { name: 'blue', hex: '#4996c8' },
    purple: { name: 'purple', hex: '#774ed8' },
    grey: { name: 'grey', hex: '#919191' },
    black: { name: 'black', hex: '#000000' },
    white: { name: 'white', hex: '#ffffff' },
    none: { name: 'none', hex: 'transparent' },
    me: { name: 'none_dark', hex: '#1da8df' },
  },
  canvas: {
    red: { name: 'red', hex: '#ffadad' },
    orange: { name: 'orange', hex: '#ffce7a' },
    yellow: { name: 'yellow', hex: '#fffcad' },
    green: { name: 'green', hex: '#d5ffa8' },
    blue: { name: 'blue', hex: '#adffff' },
    purple: { name: 'purple', hex: '#f0d1ff' },
    grey: { name: 'grey', hex: '#cccccc' },
    black: { name: 'black', hex: '#000000' },
    white: { name: 'white', hex: '#ffffff' },
    none: { name: 'none', hex: '#5fd3ff' },
    me: { name: 'none_dark', hex: '#1da8df' },
  },
  canvas_btn: {
    red: { name: 'red', hex: '#ff8282' },
    orange: { name: 'orange', hex: '#ffba47' },
    yellow: { name: 'yellow', hex: '#ebe66a' },
    green: { name: 'green', hex: '#aceb6a' },
    blue: { name: 'blue', hex: '#5cdcf2' },
    purple: { name: 'purple', hex: '#dc94ff' },
    grey: { name: 'grey', hex: '#a8a8a8' },
    black: { name: 'black', hex: '#000000' },
    white: { name: 'white', hex: '#ffffff' },
    none: { name: 'none', hex: '#0071bc' },
    me: { name: 'none_dark', hex: '#00374c' },
  },
};
